<template>
    <component-wrapper :config="$root.siteconfig.root" v-if="$store.state.translationsLoaded"/>
</template>

<script>
export default {
  name: 'App'
};

</script>
